<script>
export default {
    sign_in_with: 'Sign in with',
    or_sign_in_with_credentials: 'Or sign in with credentials',
    sign_up_with: 'Sign up with',
    generic_error: 'An error occurred. Please try again later.',
    i_agree_with_the: 'I agree with the ',
    we_have_sent_you_an_email: "We've sent you an email :-)",
    email: 'Email',
    password: 'Password',
    lost_your_password: 'Lost your password?',
    recovery_here: 'recover it here',
    sign_in: 'Sign in',
    forgot_password: 'Forgot password?',
    create_new_account: 'Create new account',
    terms_of_service: 'Terms of Service',
    link_privacy: 'Privacy Policy',
    term_conditions_text: 'By registering or signing in with one of the above services, you consent to our {link_terms} and acknowledge our {link_privacy}, which describes how we handle your personal data.',
    about_us: 'About Us',
    blog: 'Blog',
    mit_license: 'MIT License',
    docs: 'Docs',
    loading: 'Loading',
    dashboard: 'Dashboard',
    add_new_entry: 'Add new entry',
    add_new_model: 'Add new template',
    my_entries: 'My entries',
    search_entries: 'Search entries',
    payee_list: 'Payee list',
    planned_entries: 'Planned entries',
    budgets: 'Budgets',
    settings: 'Settings',
    logout: 'Logout',
    expenses: 'Expenses',
    incoming: 'Income',
    transfer: 'Transfer',
    debit: 'Debts',
    choose_one_of_currently_tags: 'Choose one of the current tags',
    choose_a_wallet_to_transfer_to: 'Choose a wallet to transfer to',
    choose_wallet_account: 'Choose wallet account',
    choose_wallet_to_transfer: 'Choose a wallet to transfer to',
    payment_confirg: 'Confirm payment',
    choose_an_option: 'Choose an option',
    choose_a_model: 'Choose a template',
    out_of_wallet: 'Out of wallet',
    insert_new_tag_name: 'Enter new tag name',
    add_here_your_note: 'Add your note here',
    insert_new_entry: 'Enter new entry',
    show_planned_entries: 'Show planned entries',
    show_more: 'Show more',
    restore: 'Restore',
    reasume_of_all_entries: 'Summary of all entries',
    list_of_all_payees: 'List of all payees',
    forget_debit: 'Forget debt',
    date_start: 'Start date',
    debit_name: 'Debt name',
    date_end: 'End date',
    choose_frequency: 'Choose frequency',
    choose_method: 'Choose method',
    insert_new_planned_entry: 'Enter new planned entry',
    create_new_budget: 'Create new budget',
    budget_name: 'Budget name',
    period: 'Period',
    budget: 'Budget',
    account: 'Account',
    category: 'Category',
    label: 'Label',
    labels: 'Labels',
    entry_type: 'Entry type',
    enable_email_notification: 'Enable email notification',
    notification_emails: 'Notification emails',
    notification_thresholds: 'Notification thresholds',
    notification_threshold_example: 'E.g.: 60 for 60%',
    save_budget: 'Save budget',
    add_new_wallet: 'Add new wallet',
    show_archived: 'Show archived',
    wallet_settings: 'Wallet settings',
    category_settings: 'Category settings',
    add_new_category: 'Add new category',
    category_name: 'Category name',
    save_changes: 'Save changes',
    archive_label: 'Archive label',
    add_model_entry: 'Add new template entry',
    model_settings: 'Template settings',
    set_your_default_currency: 'Set your default currency',
    currency_settings: 'Currency settings',
    wallets: 'Wallets',
    models: 'Templates',
    categories: 'Categories',
    currency: 'Currency',
    profile: 'Profile',
    assistance: 'Support',
    my_entry: 'My entry',
    is_planned: 'Planned',
    add: 'Add',
    model: 'Template',
    wallet: 'Wallet',
    payee: 'Payee',
    frequency: 'Frequency',
    method: 'Method',
    amount: 'Amount',
    date: 'Date',
    tag: 'Tag',
    tags: 'Tags',
    note: 'Note',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    show: 'Show',
    hide: 'Hide',
    archive: 'Archive',
    unarchive: 'Unarchive',
    search: 'Search',
    search_labels: 'Search labels...',
    or_insert_new_tag_name: 'Or enter a new tag name',
    show_details: 'Show details',
    bounce_rate: 'Bounce rate',
    session_duration: 'Session duration',
    amount_before: 'Previous amount',
    send_a_request: 'Send a request',
    change_order: 'Change order',
    add_new_workspace: 'Add new workspace',
    set_up_your_workspaces: 'Set up your workspaces',
    choose_parent_category: 'Choose a parent category',
    exclude_from_stats: 'Exclude from statistics',
    label_color: 'Label color',
    choose_currency: 'Choose a currency',
    choose_wallet_type: 'Choose a wallet type',
    payment_deadline: 'Payment deadline',
    credit_card_installment: 'Credit card installment',
    wallet_color: 'Wallet color',
    workspace_settings: 'Workspace settings',
    default_currency: 'Default currency',
    default_payment_type: 'Default payment type',
    share_workspace_with: 'Share workspace with',
    share: 'Share',
    remove: 'Remove',
    workspace_shared_with: 'Workspace shared with',
    choose_a_category: 'Choose a category',
    payment_confirm: 'Confirm payment',
    my_planned: 'Planned',
    my_health: 'Financial health',
    workspace: 'Workspace',
    entry_saved: 'Entry saved successfully',
    could_not_log_in: 'Could not log in',
    send_my_password: 'Send new password',
    recovery_your_password: 'Recover your password',
    name: 'Name',
    confirm_password: 'Confirm password',
    privacy_policy: 'Privacy & Policy',
    create_account: 'Create a new account',
    click_here: 'Click here',
    save_template: 'Save template',
    set_new_password: 'Set new password',
    account_created: 'Account created successfully, check your email to confirm and activate your account',
    search_by_text: 'Search by text',
    no: 'NO',
    yes: 'YES',
    date_interval: 'Date interval',
    type_of_transaction: 'Transaction type',
    choose_period: 'Choose a period',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    one_shot: 'One time',
    recursive: 'Recurring',
    or_nsert_new_tag_name: 'Or enter a new tag name',
    no_budgets_found: 'No budgets found',
    list_of_entries_of: 'List of entries of',
    no_payees_found: 'No payees found',
    list_of_all_budgets: 'List of all budgets',
    list_of_all_planned_entries: 'List of all planned entries',
    set_your_default_currecny: 'Set your default currency',
    update: 'Update',
    stats: 'Statistics',
    payment_types: 'Payment types',
    create_new_debit: 'Create new debt',
    months: {
        jan: 'Jan',
        january: 'January',
        feb: 'Feb',
        february: 'February',
        mar: 'Mar',
        march: 'March',
        apr: 'Apr',
        april: 'April',
        may: 'May',
        jun: 'Jun',
        june: 'June',
        jul: 'Jul',
        july: 'July',
        aug: 'Aug',
        august: 'August',
        sep: 'Sep',
        september: 'September',
        oct: 'Oct',
        october: 'October',
        nov: 'Nov',
        november: 'November',
        dec: 'Dec',
        december: 'December',
    },
    closing_account_statement: 'Closing account statement',
    account_payment: 'Payment account',
    start_date: 'Start date',
    end_date: 'End date',
    show_entries: 'Show entries',
    wallet_name: 'Wallet name',
    balance_wallet: 'Wallet balance',
    wallet_type: 'Wallet type',
    next_execution_time: 'Next execution date',
    end_time: 'End date',
    no_data_found: 'No data found',
    average_incoming: 'Average income',
    average_savings: 'Average savings',
    your_planned_expenses: 'Planned expenses',
    average_expenses: 'Average expenses',
    list_of_voices: 'List of entries',
    no_voices_found: 'No entries found',
    workspace_whared_with: 'Workspace shared with',
    user_not_found: 'User not found',
    save_as_model: 'Save as template',
    write_temlate_name: 'Enter template name',
    end_of_month: 'End of month forecast',
    ticket_value: 'Voucher value',
    spent: 'spent',
    remaining: 'remaining',
    planned: 'planned',
    no_entries_found: 'No entries found',
    credit_card_installement: 'Credit card installment',
    choose_planned_type: 'Choose planned type',
    list_of_all_credit_cards: 'List of all credit cards',
    details: 'Details',
    planned_entry: 'Planned',
    back_to_login: 'Back to login',
    workspace_name: 'Your workspace name',
    first_wallet_name: 'Your first wallet name',
    wallet_amount: 'Wallet balance',
    setup_account: 'Set up account',
    donate: 'Donate',
    faq: 'FAQ',
    start_Date: 'Start date',
    savings: 'Savings',
    paid_debits: 'Debts',
    given_on_loan: 'Given on loan',
    loans: 'Loans',
    goals: 'Goals',
    list_of_all_goals: 'List of all goals',
    no_goals_found: 'No goals found',
    add_new_goal: 'Add new goal',
    target_amount: 'Amount',
    goal_name: 'Goal name',
    goal_target: 'Target date',
    goal_note: 'Notes',
    icons: {
        house: 'House',
        car: 'Car',
        travel: 'Travel',
        education: 'Education',
        health: 'Health',
        savings: 'Savings',
        retirement: 'Retirement',
        business: 'Business',
        charity: 'Charity',
        family: 'Family',
        hobby: 'Hobby',
        investment: 'Investment',
        emergency: 'Emergency',
        vacation: 'Vacation',
        home_improvement: 'Home Improvement',
        technology: 'Technology',
        pets: 'Pets',
        other: 'Other',
    },
    goal_type: 'Goal type',
    activity: 'Activity',
    deposit: 'Deposit',
    saved: 'Saved',
    my_goal: 'My goal',
    my_goals: 'My goals',
    current_saved: 'Currently saved',
    monthly_deposit: 'Monthly deposit',
    due_date: 'Due date',
    description: 'Description',
    choose_a_goal: 'Select a goal',
    withdrawal: 'Withdrawal',
    choose_payment_type: 'Choose payment type',
    no_goals_available: 'No goals available',
    create_goal_to_start_saving: 'Create a goal to start saving',
    create_first_goal: 'Create your first goal',
    operation_type: 'Operation type',
    attention: 'Attention',
    choose_payee: 'Choose payee',
    insert_payee_name: 'Enter payee name',
    wallets_must_be_different: 'Wallets must be different',
    create_goal_first: 'Create a goal first',
    label_input_hint: 'You can add multiple labels separated by spaces',
    no_models_available: 'No templates available',
    create_first_model: 'Create your first template',
    your_goal: 'Your goal',
    confirm_delete_goal: 'Confirm goal deletion',
    remaining_expenses: 'Remaining expenses',
    wallet_management: 'Wallet management',
    wallet_management_description: 'Manage your wallets, add new ones and set your default wallet.',
    add_first_wallet: 'Add your first wallet',
    no_wallets_available: 'No wallets available',
    create_first_wallet: 'Create your first wallet',
    archived: 'Archived',
    last_updated: 'Last updated',
    active_wallets: 'Active wallets',
    all_wallets: 'All wallets',
    archived_wallets: 'Archived wallets',
    last_update: 'Last update',
    click_to_create_wallet: 'Click to create a wallet',
    add_wallet: 'Add wallet',
    credit_card_settings: 'Credit Card Settings',
    voucher_settings: 'Voucher Settings',
    additional_options: 'Additional Options',
    enter_initial_balance: 'Enter initial balance',
    edit_wallet: 'Edit Wallet',
    initial_balance: 'Initial balance',
    label_settings: 'Label settings',
    manage_your_labels: 'Manage your labels, add new ones or archive unused ones',
    add_new_label: 'Add new label',
    edit_label: 'Edit label',
    add_label: 'Add label',
    label_name: 'Label name',
    active_labels: 'Active labels',
    all_labels: 'All labels',
    archived_labels: 'Archived labels',
    no_labels_found: 'No labels found',
    balance: 'Balance',
    active: 'Active',
    manage_your_workspaces: 'Manage your workspaces',
    edit_workspace: 'Edit workspace',
    user_shared: 'User shared',
    enter_email: 'Enter email',
    no_workspaces_found: 'No workspaces found',
    reset: 'Restore',
    category_details: 'Category details',
    expenses_by_category_monthly: 'Expenses by category (monthly)',
    expenses_by_category_comparison: 'Expenses by category (comparison)',
    manage_your_models: 'Manage your templates, add new ones or archive unused ones',
    write_template_name: 'Enter template name',
    sort_name_asc: 'Name (A-Z)',
    sort_name_desc: 'Name (Z-A)',
    sort_amount_desc: 'Amount (High to Low)',
    sort_amount_asc: 'Amount (Low to High)',
}
</script>